import Locale from '@/helper/locale/Locale.js';
import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager';

/**
 * @export CampaignConfigModel
 * @export CampaignConfigBuilder
 * @export CampaignListConfigModel
 * @export CampaignListConfigBuilder
 * @export CampaignListFilterConfigModel
 * @export CampaignListFilterConfigBuilder
 */

//#region Campaign
export function BranchConfigModel() {
    this.lat = null;
    this.lng = null;
    this.locale = Locale.getLocaleCode();
    this.distance  = 1500000;
    this.mode = "nearby";
    this.withinArea  = 0;
    this.requireCampaign = 0;
    this.agencyId = ConfigManager.getAgencyId();
    this.isPickupBranchOpen = null; 

    this.getParams = function() {
        var params = {
            center: this.lat + ',' + this.lng,
            device_locale: this.locale ,
            distance: this.distance,
            mode: this.mode,
            within_area: this.withinArea,
            require_campaign: this.requireCampaign,
            agencyId: this.agencyId,
            IsPickupBranchOpen: this.isPickupBranchOpen 
        };
        params = Util.cleanObjectEmptyStr(params);
        return params
    };
}
export function BranchConfigBuilder() {
    this.branchConfig = new BranchConfigModel();

    this.create = () => {
        return this.branchConfig;
    };

    this.setCenter = (lat,lng) => {
        this.branchConfig.lat = lat;
        this.branchConfig.lng = lng;
        return this;
    };

    this.setDistance = (distance) => {
        this.branchConfig.distance = distance;
        return this;
    };

    this.setAgencyId = (agencyId) => {
        this.branchConfig.agencyId = agencyId;
        return this;
    };

    this.setIsPickupBranchOpen = (isPickupBranchOpen) => {
        this.branchConfig.isPickupBranchOpen = isPickupBranchOpen;
        return this;
    };

}
//#endregion Campaign

